(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-image-with-text"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  // Select all paragraph elements with the class 'image-with-text__text'
  const paragraphs = document.querySelectorAll(".image-with-text__text");

  paragraphs.forEach((paragraph) => {
    const lineHeight = parseFloat(window.getComputedStyle(paragraph).lineHeight);
    const maxLines = 8;
    const maxHeight = lineHeight * maxLines;

    if (paragraph.scrollHeight > maxHeight) {
      paragraph.classList.add("text-collapsed");
      const readMoreBtn = document.createElement("button");
      readMoreBtn.textContent = "Read More";
      readMoreBtn.className = "read-more-btn";
      if (paragraph.closest(".section-1")) {
        readMoreBtn.classList.add("section-1-btn");
      } else if (paragraph.closest(".section-2")) {
        readMoreBtn.classList.add("section-2-btn");
      }

      paragraph.parentNode.appendChild(readMoreBtn);

      readMoreBtn.addEventListener("click", function () {
        if (paragraph.classList.contains("text-collapsed")) {
          paragraph.classList.remove("text-collapsed");
          readMoreBtn.textContent = "Read Less";
        } else {
          paragraph.classList.add("text-collapsed");
          readMoreBtn.textContent = "Read More";
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["circle-animations"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      const circleItems = document.querySelectorAll('.circle-item');
      let lastScrollTop = 0;
      const handleScroll = () => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop; // Get the current scroll position
          console.log('scrolling');
          // if (scrollTop > lastScrollTop + 10) {
            circleItems.forEach(div => {
                const rect = div.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const windowWidth = window.innerWidth || document.documentElement.clientWidth;

                // Check if the .circle-item is in the viewport
                console.log(rect.top, windowHeight, rect.bottom)
                if (rect.top <= 600  &&
                  rect.left >= 0 &&
                  rect.right <= windowWidth) {
                    // Only move the target element if its parent is in view
                    const targetElement = div.querySelector('.top');
                    if (targetElement) {
                        targetElement.style.bottom = 'unset';
                        targetElement.classList.add('move-down');
                    }

                    const targetElement2 = div.querySelector('.bottom');
                    if (targetElement2) {
                      targetElement2.style.right = 'unset';
                      targetElement2.classList.add('move-left');
                    }
                }
             });
          // }
          // else {
          //   console.log('scrolling up');
          // }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      };

      // Add scroll event listener
      window.addEventListener('scroll', handleScroll);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-story"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const phaseBlocks = document.querySelectorAll('.phase-block');
    const hoverDescriptions = document.querySelectorAll('.hover-description');

    phaseBlocks.forEach(block => {
        block.addEventListener('mousemove', (event) => {
            const parentBlock = document.querySelector('.story-mission-phases-wrapper');
            const phaseId = block.getAttribute('data-phase-id');
            const matchingDescription = document.querySelector(`.hover-description[data-phase-id="${phaseId}"]`);

            if (matchingDescription) {
                // Position the description relative to the mouse pointer
                const parentRect = block.getBoundingClientRect();
                const mouseX = event.clientX;
                const mouseY = event.clientY - parentRect.top;
                console.log(mouseY, parentRect.top, parentBlock.getBoundingClientRect().top)
                matchingDescription.style.top = `${event.clientY - parentBlock.getBoundingClientRect().top + 15}px`; // Offset by 15px below the pointer

                // Apply styles for visibility and animation
                matchingDescription.style.opacity = '1';
                matchingDescription.style.visibility = 'visible';
                matchingDescription.style.transform = 'translateY(0)';
                matchingDescription.style.transition = 'opacity 0.5s ease, visibility 0.5s ease, transform 0.3s ease';
            } else {
                console.error('No matching description found for phase ID:', phaseId);
            }
        });

        block.addEventListener('mouseout', () => {
            hoverDescriptions.forEach(description => {
                description.style.opacity = '0';
                description.style.visibility = 'hidden';
                description.style.transform = 'translateY(10px)'; // Move back to initial position for animation
            });
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-circles"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const circles = document.querySelectorAll('.ingredient-circle');
  const container = document.querySelector('.circles-container');
  const moveDistance = 80; // Distance to move in a circular path before moving away
  const fadeStartDistance = 50; // Distance at which circles start to fade out
  const speedFactor = 2.2; // Factor to increase the speed of the movement

  function positionCircles() {
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;
    const centerX = containerWidth / 2;
    const centerY = containerHeight / 2;
    const numCircles = circles.length;

    const radius = (containerHeight - containerHeight * 0.22) / 2;
    const horizontalRadius = radius * (containerWidth / containerHeight);

    circles.forEach((circle, index) => {
      const angle = (index * (360 / numCircles)) * (Math.PI / 180);

      // Calculate circle position
      const posX = centerX + radius * Math.cos(angle);
      const posY = centerY + radius * Math.sin(angle);

      // Set initial circle size and position
      const circleSize = Math.min(containerWidth, containerHeight) * 0.22; // Adjust size as needed
      circle.style.width = `${circleSize}px`;
      circle.style.height = `${circleSize}px`;
      circle.style.position = 'absolute'; 
      circle.style.left = `${posX - circleSize / 2}px`;
      circle.style.top = `${posY - circleSize / 2}px`;
      circle.style.opacity = "1";
      circle.style.transition = "transform 0.5s ease-out, opacity 0.5s ease-out";
    });
  }

  function handleScrollAnimation() {
    const scrollPosition = window.scrollY;
    const totalScrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollPosition / totalScrollHeight;

    // Calculate distance moved in circular motion with increased speed
    // const distanceCovered = Math.min(progress * totalScrollHeight * speedFactor, moveDistance);
    const rect = container.getBoundingClientRect();
    const distanceCovered = - rect.top/3;
    console.log('Distance',rect.top)
    circles.forEach((circle, index) => {
      const angleOffset = progress * 360 * speedFactor + index * (360 / circles.length);
      const angleInRadians = angleOffset * (Math.PI / 180);

      // Calculate movement in circular path
      const circularX = distanceCovered * Math.cos(angleInRadians);
      const circularY = distanceCovered * Math.sin(angleInRadians);

      // Calculate movement away from the Y position and fade effect
      const fadeProgress = Math.min(1, (distanceCovered - fadeStartDistance) / fadeStartDistance);
      const moveAwayX = fadeProgress * 50 * Math.cos(angleInRadians) * speedFactor; // Adjust the move away factor as needed
      const moveAwayY = fadeProgress * 50 * Math.sin(angleInRadians) * speedFactor; // Adjust the move away factor as needed

      // Apply the circular movement and fade effect
      circle.style.transform = `translate(${circularX + moveAwayX}px, ${circularY + moveAwayY}px)`;
      // circle.style.opacity = 1 - fadeProgress; // Uncomment to fade out gradually
    });
  }

  positionCircles();
  window.addEventListener('resize', positionCircles);
  window.addEventListener('scroll', handleScrollAnimation);
});

  } catch(e) { console.error(e); }
})();
})();
